export enum IDistributionOfLandedCostsMethodEnum {
    Auto,
    Manual
}